import { render, staticRenderFns } from "./document-history-edited.vue?vue&type=template&id=58b84954&scoped=true&lang=pug&"
import script from "./document-history-edited.vue?vue&type=script&lang=ts&"
export * from "./document-history-edited.vue?vue&type=script&lang=ts&"
import style0 from "./document-history-edited.vue?vue&type=style&index=0&id=58b84954&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b84954",
  null
  
)

export default component.exports